export function removePonctuation (text) {
    return text.toLowerCase()
        .replace(/ /g, '-')
        .replace(/#/g, '')
        .replace(new RegExp('[ÁÀÂÃ]', 'gi'), 'a')
        .replace(new RegExp('[ÉÈÊ]', 'gi'), 'e')
        .replace(new RegExp('[ÍÌÎ]', 'gi'), 'i')
        .replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'o')
        .replace(new RegExp('[ÚÙÛ]', 'gi'), 'u')
        .replace(new RegExp('[Ç]', 'gi'), 'c')
}

export function decodeEntitiesHtml (str) {
    const txt = document.createElement('textarea')
    txt.innerHTML = str
    return txt.value
}

export function getQueryVariable (variable) {
    const query = window.location.search.substring(1)
    const vars = query.split('&')
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=')
        if (pair[0] === variable) {
            return pair[1]
        }
    }
    return (false)
}

export function slugify (str) {
    return str.toLowerCase()
        .replace(/[àÀáÁâÂãäÄÅåª]+/g, 'a') // Special Characters #1
        .replace(/[èÈéÉêÊëË]+/g, 'e') // Special Characters #2
        .replace(/[ìÌíÍîÎïÏ]+/g, 'i') // Special Characters #3
        .replace(/[òÒóÓôÔõÕöÖº]+/g, 'o') // Special Characters #4
        .replace(/[ùÙúÚûÛüÜ]+/g, 'u') // Special Characters #5
        .replace(/[ýÝÿŸ]+/g, 'y') // Special Characters #6
        .replace(/[ñÑ]+/g, 'n') // Special Characters #7
        .replace(/[çÇ]+/g, 'c') // Special Characters #8
        .replace(/[ß]+/g, 'ss') // Special Characters #9
        .replace(/[Ææ]+/g, 'ae') // Special Characters #10
        .replace(/[Øøœ]+/g, 'oe') // Special Characters #11
        .replace(/[%]+/g, 'pct') // Special Characters #12
        .replace(/\s+/g, '-') // Replace spaces with -
        // eslint-disable-next-line no-useless-escape
        .replace(/[^\w\-]+/g, '') // Remove all non-word chars
        // eslint-disable-next-line no-useless-escape
        .replace(/\-\-+/g, '-') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, '') // Trim - from end of text
}
